import * as MasterService from "@/apiServices/MastersServices";
import { setAbilities } from "@/libs/acl/setAbilities";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    user_authenticated: false,
    user_details: {
      name: "Firstname",
      email: "Lastname",
      role_name: "User",
    },
    new_notifications: [],
    new_notifications_count: 0,
    sseConnection: null,
  },
  getters: {
    getUserDetails: (state) => state.user_details,
    getUserAuthenticated: (state) => state.user_authenticated,
    getNewNotifications: (state) => state.new_notifications,
  },
  mutations: {
    SET_USER_AUTHENTICATED(state, val) {
      state.user_authenticated = val;
    },
    SET_USER_DETAILS(state, val) {
      state.user_details = { ...state.user_details, ...val };
    },
    SET_NEW_NOTIFICATIONS(state, val) {
      state.new_notifications = val;
    },
    SET_NEW_NOTIFICATIONS_COUNT(state, val) {
      state.new_notifications_count = val;
    },
    ADD_NEW_NOTIFICATION(state, notification) {
      state.new_notifications.unshift(notification);
      state.new_notifications_count++;
    },
    SET_SSE_CONNECTION(state, val) {
      state.sseConnection = val;
    },
    CLEAR_USER_STATE(state) {
      state.user_authenticated = false;
      state.user_details = {
        name: "Firstname",
        email: "Lastname",
        role_name: "User",
      };
      state.new_notifications = [];
      state.new_notifications_count = 0;
      if (state.sseConnection) {
        state.sseConnection.close();
        state.sseConnection = null;
      }
    },
  },
  actions: {
    setUserDetails: async ({ dispatch, commit, state }, payload) => {
      MasterService.getProfile()
        .then(async (response) => {
          if (response.data.status) {
            if (
              response.data.data.access_map &&
              response.data.data.access_map.length
            ) {
              // console.log(
              //   response.data.data.access_map,
              //   "response.data.data.access_map"
              // );
              setAbilities(response.data.data.access_map);
            }
            await commit("SET_USER_DETAILS", response.data.data);
            await commit("SET_USER_AUTHENTICATED", true);
          }
        })
        .catch((err) => {
          console.log("Error in getting user profile ", err);
        });
    },
    setNewNotifications: async ({ dispatch, commit, state }, payload) => {
      MasterService.getNewNotifications()
        .then(async (response) => {
          if (response.data.status) {
            const arr = response.data.data.concat(state.new_notifications);
            await commit(
              "SET_NEW_NOTIFICATIONS_COUNT",
              state.new_notifications_count + response.data.data.length,
            );
            await commit("SET_NEW_NOTIFICATIONS", arr);
          }
        })
        .catch((err) => {
          console.log("Error in setting new notifications ", err);
        });
    },
    connectSSE: ({ commit, state, dispatch }) => {
      if (state.sseConnection) return;

      const token = localStorage.getItem("access_token");
      const sse = new EventSource(
        `${process.env.VUE_APP_BASEURL}/sse/notification?authorization=${token}`,
      );

      commit("SET_SSE_CONNECTION", sse);

      sse.addEventListener("notification", async (event) => {
        await dispatch("setNewNotifications");
      });

      sse.onerror = () => {
        sse.close();
        commit("SET_SSE_CONNECTION", null);
      };
    },
    disconnectSSE: ({ state, commit }) => {
      if (state.sseConnection) {
        state.sseConnection.close();
        commit("SET_SSE_CONNECTION", null);
      }
    },
    async logout({ commit, dispatch }) {
      commit("CLEAR_USER_STATE");
      setAbilities([]);
      dispatch("disconnectSSE");
      if (router && router.currentRoute.path !== "/login") {
        router.push("/login");
      }
    },
  },
};
